export default theme => ({
    compareButton: {
        whiteSpace: 'nowrap',
        fontWeight: 700,
        color: theme.palette.grey[900],
        fontSize: 13
    }
});
